import { IMenuItem } from '@platform500services/p500-ui-kit';
import { RbacPermissionsConstant } from '../../services/rbac/rbac-permissions.constant';

export const MENU_CONFIG: IMenuItem[] = [
  {
    title: $localize`:@@common.dashboard:Dashboard`,
    link: '/app/dashboard',
    icon: 'p500-ui-icon-home',
  },
  {
    title: $localize`:@@common.offers:Offers`,
    icon: 'p500-ui-icon-tags',
    link: '/app/traffic-control/offers',
    permission: RbacPermissionsConstant.PAGES_TABLE_OFFERS,
  },
  {
    title: $localize`:@@common.affiliates:Affiliates`,
    icon: 'p500-ui-icon-users',
    children: [
      [
        {
          title: $localize`:@@common.affiliates:Affiliates`,
          link: '/app/affiliates/affiliates',
          permission: RbacPermissionsConstant.PAGES_TABLE_AFFILIATES,
        },
        {
          title: $localize`:@@affiliate.trackers:Affiliate Trackers`,
          link: '/app/affiliates/affiliates-trackers',
          permission: RbacPermissionsConstant.PAGES_TABLE_AFFILIATES_TRACKERS,
        },
        {
          title: $localize`:@@affiliate.requests:Affiliate Requests`,
          link: '/app/affiliates/affiliates-requests',
          permission: RbacPermissionsConstant.PAGES_TABLE_AFFILIATE_REQUESTS,
        },
      ],
    ],
  },
  {
    title: $localize`:@@common.advertisers:Advertisers`,
    icon: 'p500-ui-icon-building',
    link: '/app/advertisers/advertisers',
    permission: RbacPermissionsConstant.PAGES_TABLE_ADVERTISERS,
  },
  {
    title: $localize`:@@common.traffic_data:Traffic Data`,
    icon: 'p500-ui-icon-folders',
    children: [
      [
        {
          title: $localize`:@@common.clicks:Clicks`,
          link: '/app/traffic-data/clicks',
          permission: RbacPermissionsConstant.PAGES_TABLE_CLICKS,
          table: 'ClicksTable',
        },
        {
          title: $localize`:@@common.conversions:Conversions`,
          link: '/app/traffic-data/conversions',
          permission: RbacPermissionsConstant.PAGES_TABLE_CONVERSIONS,
        },
      ],
    ],
  },
  {
    title: $localize`:@@common.reports:Reports`,
    icon: 'p500-ui-icon-chart-board',
    children: [
      [
        {
          title: $localize`:@@common.data_exporter:Data Exporter`,
          link: '/app/reporting/data-exporter',
          permission: RbacPermissionsConstant.PAGES_SPECIAL_REPORT_BUILDER,
        },
        {
          title: $localize`:@@common.drilldown:Drilldown`,
          link: '/app/reporting/drilldown-reports',
          permission: RbacPermissionsConstant.PAGES_SPECIAL_DRILLDOWN,
        },
        {
          title: $localize`:@@common.new_drilldown:New Drilldown`,
          link: '/app/reporting/drilldown',
          permission: RbacPermissionsConstant.PAGES_SPECIAL_NEW_DRILLDOWN,
        },
        {
          title: $localize`:@@common.comparing_analytics:Comparing Analytics`,
          link: '/app/reporting/comparing-analytics',
          permission: RbacPermissionsConstant.PAGES_TABLE_COMPARING_ANALYTICS,
        },
        {
          title: $localize`:@@cohort.report:Cohort Report`,
          link: '/app/reporting/cohort-report',
          permission: RbacPermissionsConstant.PAGES_SPECIAL_COHORT_REPORT,
        },
      ],
    ],
  },
  {
    title: $localize`:@@common.billing:Billing`,
    icon: 'p500-ui-icon-wallet',
    children: [
      [
        {
          title: $localize`:@@common.deals_history:Deals History`,
          permission: RbacPermissionsConstant.PAGES_TABLE_DEAL_HISTORY,
          link: '/app/finance-tools/deals-history',
        },
        {
          title: $localize`:@@common.deals_updater:Deals Updater`,
          permission: RbacPermissionsConstant.PAGES_SPECIAL_DEALS_UPDATER,
          link: '/app/finance-tools/deals-updater',
        },
        // {
        //   title: 'Affiliate Invoices',
        //   link: '/app/affiliates/affiliate-invoices',
        //   permission: RbacPermissionsConstant.PAGES_TABLE_AFFILIATES_INVOICES,
        // },
        {
          title: $localize`:@@common.earnings:Earnings`,
          permission: RbacPermissionsConstant.PAGES_TABLE_EARNING,
          link: '/app/finance-tools/earnings',
        },
        {
          title: $localize`:@@common.invoices:Invoices`,
          link: '/app/finance-tools/finance-invoices',
          permission: RbacPermissionsConstant.PAGES_TABLE_INVOICE,
        },
        {
          title: $localize`:@@common.payments:Payments`,
          link: '/app/finance-tools/finance-payments',
          permission: RbacPermissionsConstant.PAGES_TABLE_PAYMENT,
        },
      ],
    ],
  },
  {
    title: $localize`:@@common.api:API`,
    icon: 'p500-ui-icon-code',
    permission: RbacPermissionsConstant.PAGES_TABLE_TOKENS,
    link: '/app/settings/crm-tokens',
  },
];
